import React from 'react';
import ReactDOM from 'react-dom/client';
import AppStore from 'utils/redux/store';
import AppRoute from 'config/route'
import { Routes } from "react-router";
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={AppStore}>
      <BrowserRouter>
        <Routes children={AppRoute} />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);